import React from "react";
import { Box, Button } from "@mui/material";

const ActionButton = ({ onClick, children, variant }) => {
  const baseStyles = {
    px: 3,
    py: 1.5,
    borderRadius: 2,
    fontWeight: 600,
    transition: "all 0.2s ease",
  };

  const outlinedStyles = {
    ...baseStyles,
    border: "2px solid #e5e7eb",
    backgroundColor: "#fff",
    color: "#374151",
    "&:hover": {
      borderColor: "#d1d5db",
      backgroundColor: "#f9fafb",
    },
  };

  const gradientStyles = {
    ...baseStyles,
    background: "linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)",
    color: "#fff",
    boxShadow: "0 4px 12px rgba(99, 102, 241, 0.3)",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 6px 20px rgba(99, 102, 241, 0.4)",
    },
  };

  return <Button onClick={onClick} sx={variant === "gradient" ? gradientStyles : outlinedStyles}>{children}</Button>;
};

const CreatePassengerModalActions = ({
  handleClose,
  handleInputsReset,
  handleAddingReservation,
  isUpdate,
  handleUpdatingReservation,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        gap: 2,
        mt: 4,
        pt: 3,
        borderTop: "1px solid #e5e7eb",
        justifyContent: "flex-end",
        flexWrap: "wrap",
      }}
    >
      <ActionButton onClick={handleClose}>Izađi</ActionButton>
      <ActionButton onClick={handleInputsReset}>Reset</ActionButton>

      {!isUpdate ? (
        <ActionButton onClick={handleAddingReservation} variant="gradient">
          Dodaj Rezervaciju
        </ActionButton>
      ) : (
        <ActionButton onClick={handleUpdatingReservation} variant="gradient">
          Edituj Rezervaciju
        </ActionButton>
      )}
    </Box>
  );
};

export default CreatePassengerModalActions;
